import React from "react";
import {PROJECT_ID, URL} from '../../config';

const MenuContext = React.createContext();

export const MenuProvider = ({ children }) => {
    const [routes, setRoutes] = React.useState([]);

    const readJson = async() => {
        let params = [];
        await fetch(URL+'routes.json').then(res => res.json())
        .then(data => {
          data[PROJECT_ID].forEach(item => {
            if(item.containParam){
              params.push({...item, hide: true, route: item.route + '/:' + item.params});
            }
          })
          
          setRoutes([...data[PROJECT_ID], ...params]);
        })
      }

    React.useEffect(() => {
        readJson();
    }, [])

    return (
        <MenuContext.Provider value={{ routes }}>
            {children}
        </MenuContext.Provider>
    );
}

export { MenuContext };
